<template>
    <v-dialog
        v-model="showDialog"
        persistent
        max-width="500px"
    >
        <v-card height="250px">
            <v-container class="my-2">
                <v-card-title class="text-md-h6 text-center text-break mb-3 font-weight-bold">
                    {{ $t('reports.messages.delete_report_question', {reportTitle: report.title}) }}
                </v-card-title>

                <v-card-subtitle class="text-center">
                    {{ $t('reports.messages.delete_report_warning_message') }}
                </v-card-subtitle>

                <v-card-actions class="justify-center">
                    <v-btn
                        class="v-btn--red"
                        text
                        @click="confirmDelete"
                    >{{ $t('app.confirm') }}</v-btn>

                    <v-btn
                        class="v-btn--secondary"
                        text
                        @click="closeDialog"
                    >{{ $t('app.cancel') }}</v-btn>

                    <v-progress-circular
                        indeterminate
                        class="mt-2 ml-2"
                        v-if="deletingReport"
                        color="grey"
                        size="16"
                    ></v-progress-circular>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import {EventBus} from "@/event-bus";

export default {
    name: "DeleteReportDialog",

    props: {
        showDialog: {
            type: Boolean,
            default: false,
            required: true
        },
        report: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            deletingReport: false,
        }
    },

    methods: {

        /**
         * Emits dialog confirmed event
         */
        confirmDelete() {
            this.deletingReport = true;

            this.$emit('confirmReportDeletion');
        },

        /**
         * Closes the deletion dialog
         */
        closeDialog() {
            this.$emit('cancelReportDeletion');
        },

        /**
         * Hides spinner after delete report succeed
         */
        stopReportDeletingSpinner() {
            this.deletingReport = false;
        }
    },

    created() {
        EventBus.$on('reports.management.delete-report', this.stopReportDeletingSpinner)
    }
}
</script>

<style scoped>

</style>
